import { AppUser } from "models/AppUser";
import { ModelFilter } from "react3l-common";

export enum GLOBAL_STATE_ACTION {
  UPDATE_USER,
  UPDATE_SPINNING,
  UPDATE_FILTER,
}

export interface GlobalStateModel {
  user: AppUser;
  spinning: boolean;
  filter: ModelFilter;
}
